import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export type EmailCategory = 'messages' | 'meetings' | 'mentions';

export interface EmailSettings {
  enabled: boolean;
  digest: boolean;
  types: Record<EmailCategory, boolean>;
}

export interface EmailSettingsUpdate {
  enabled?: boolean;
  digest?: boolean;
  types?: Partial<Record<EmailCategory, boolean>>;
}

@Injectable({ providedIn: 'root' })
export class EmailNotificationsService {
  private http = inject(HttpClient);
  private base = '/api/users/email-notifications';

  /**
   * Fetches the current user's email notification settings.
   * @returns {Observable<EmailSettings>}
   */
  getSettings(): Observable<EmailSettings> {
    return this.http.get<EmailSettings>(this.base);
  }

  /**
   * Updates any of the current user's email notification settings.
   * @param {EmailSettingsUpdate} update - the settings to change; anything left out is unchanged.
   * @returns {Observable<EmailSettings>} the full settings after the update.
   */
  updateSettings(update: EmailSettingsUpdate): Observable<EmailSettings> {
    return this.http.patch<EmailSettings>(this.base, update);
  }
}
